import { render } from "./LoginAdmin.vue?vue&type=template&id=c64c6af8"
import script from "./LoginAdmin.vue?vue&type=script&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&lang=js"

import "./LoginAdmin.vue?vue&type=style&index=0&id=c64c6af8&lang=css"
script.render = render

export default script